import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { Container } from '@mui/material';
import { useAppSelector } from '../../modules/store/storeHooks';
import { UserType } from '../../modules/login/loginTypes';
import { selectUserType } from '../../modules/login/loginSelectors';
import { MerchantNav } from './MerchantNav';
import { OfficeManagerNav } from './OfficeManagerNav';
import { useMatch } from 'react-router-dom';
import { MERCHANT_ADMIN_ROUTE } from '../../constants/routes';
import { MerchantNavAdmin } from './MerchantNavAdmin';

function NavigationContent() {
    const userType = useAppSelector(selectUserType)

    const matchAdmin = useMatch(`${MERCHANT_ADMIN_ROUTE}/*`)


    switch (userType) {
        case UserType.MERCHANT: {

            return matchAdmin ?
                <MerchantNavAdmin /> : (<MerchantNav />)
        }
        case UserType.OFFICE_MANAGER: {
            return <OfficeManagerNav />
        }

        default: {
            // TODO handle navigation erros
            return (<p>error in navigation</p>)

        }
    }
}

export function Navigation() {


    return (
        <AppBar position="sticky" color='inherit' sx={{ backgroundColor: "black" }} >
            <Container>
                <Toolbar >
                    <NavigationContent />
                </Toolbar>
            </Container>
        </AppBar>

    )
}
